var map = {
	"./_resources/cldc/cldc9_1.jpg": 436,
	"./_resources/cldc/cldc9_10.jpg": 437,
	"./_resources/cldc/cldc9_11.jpg": 438,
	"./_resources/cldc/cldc9_12.jpg": 439,
	"./_resources/cldc/cldc9_13.jpg": 440,
	"./_resources/cldc/cldc9_14.jpg": 441,
	"./_resources/cldc/cldc9_15.jpg": 442,
	"./_resources/cldc/cldc9_16.jpg": 443,
	"./_resources/cldc/cldc9_2.jpg": 444,
	"./_resources/cldc/cldc9_3.jpg": 445,
	"./_resources/cldc/cldc9_4.jpg": 446,
	"./_resources/cldc/cldc9_5.jpg": 447,
	"./_resources/cldc/cldc9_6.jpg": 448,
	"./_resources/cldc/cldc9_7.jpg": 449,
	"./_resources/cldc/cldc9_8.jpg": 450,
	"./_resources/cldc/cldc9_9.jpg": 451,
	"./_resources/cldc/cldc9_poster.png": 452,
	"./_resources/corpora/corpora_PTT.jpg": 453,
	"./_resources/corpora/corpora_formosan.jpg": 454,
	"./_resources/facilities/EGG.jpg": 455,
	"./_resources/facilities/EMG.jpg": 456,
	"./_resources/facilities/ERP.png": 457,
	"./_resources/facilities/default_image.jpg": 458,
	"./_resources/facilities/eye_tracker.jpg": 459,
	"./_resources/facilities/sound_proof_recording_room.jpeg": 460,
	"./_resources/facilities/ultrasound_probe_stablization_headset.jpeg": 461,
	"./_resources/facilities/ultrasound_probe_stablization_system-compressor.jpg": 462,
	"./_resources/facilities/ultrasound_technology.jpg": 463,
	"./_resources/ntue/Articut01.png": 464,
	"./_resources/ntue/C_Hendrix_Sun.jpg": 465,
	"./_resources/ntue/H_Baayen.jpg": 466,
	"./_resources/ntue/H_Yang.jpg": 467,
	"./_resources/ntue/P_Hendrix.jpg": 468,
	"./_resources/ntue/Y_Chang.jpg": 469,
	"./_resources/ntue/Y_Chuang.jpg": 470,
	"./_resources/ntue/ma.png": 471,
	"./_resources/ntue/ntue_1.jpg": 472,
	"./_resources/ntue/ntue_2.jpg": 473,
	"./_resources/ntue/photo_album/1128.jpg": 474,
	"./_resources/ntue/photo_album/DSC03491.JPG": 475,
	"./_resources/ntue/photo_album/DSC03495.JPG": 476,
	"./_resources/ntue/photo_album/DSC03527.JPG": 477,
	"./_resources/ntue/photo_album/DSC03532.JPG": 478,
	"./_resources/ntue/photo_album/DSC03534.JPG": 479,
	"./_resources/ntue/photo_album/DSC03537.JPG": 480,
	"./_resources/ntue/photo_album/DSC03543.JPG": 481,
	"./_resources/ntue/photo_album/DSC03553.JPG": 482,
	"./_resources/ntue/photo_album/DSC03556.JPG": 483,
	"./_resources/ntue/photo_album/DSC03563.JPG": 484,
	"./_resources/ntue/photo_album/DSC03572.JPG": 485,
	"./_resources/ntue/photo_album/DSC03586.JPG": 486,
	"./_resources/ntue/photo_album/DSC03592.JPG": 487,
	"./_resources/ntue/photo_album/DSC03599.JPG": 488,
	"./_resources/ntue/photo_album/IMG_20191128_112118.jpg": 489,
	"./_resources/ntue/photo_album/IMG_20191128_171651.jpg": 490,
	"./_resources/ntue/photo_album/IMG_7052.png": 491,
	"./_resources/ntue/photo_album/IMG_7056.jpg": 492,
	"./_resources/ntue/photo_album/IMG_7061.jpg": 493,
	"./_resources/ntue/photo_album/IMG_7064.jpg": 494,
	"./_resources/ntue/photo_album/IMG_7073.jpg": 495,
	"./_resources/ntue/photo_album/IMG_7082.jpg": 496,
	"./_resources/ntue/photo_album/IMG_7095.jpg": 497,
	"./_resources/ntue/photo_album/IMG_7104.jpg": 498,
	"./_resources/ntue/photo_album/IMG_7112.jpg": 499,
	"./_resources/ntue/photo_album/IMG_7122.jpg": 500,
	"./_resources/ntue/photo_album/IMG_7128.jpg": 501,
	"./_resources/ntue/photo_album/IMG_7140.jpg": 502,
	"./_resources/ntue/photo_album/IMG_7144.jpg": 503,
	"./_resources/ntue/photo_album/NTUEworkshop-1128-00010.JPG": 504,
	"./_resources/ntue/photo_album/NTUEworkshop-1128-00018.jpg": 505,
	"./_resources/ntue/photo_album/NTUEworkshop-1129-00002.jpg": 506,
	"./_resources/online_courses/online_courses_Chao_Yuen-Ren.jpg": 507,
	"./_resources/online_courses/online_courses_Su_I-Wen.jpg": 508,
	"./_resources/online_courses/online_courses_Wang_Shi-Yuan.jpg": 509,
	"./_resources/rogil/rogil.jpg": 510,
	"./_resources/tol/LingHacks2017.jpg": 511,
	"./_resources/tol/LingHacks2018.jpg": 512,
	"./_resources/tol/LingHacks2019.jpg": 513,
	"./_resources/tol/LingHacks_1.jpg": 514,
	"./_resources/tol/LingHacks_2.jpg": 515,
	"./_resources/tol/LingHacks_3.jpg": 516,
	"./_resources/tol/LingHacks_4.jpg": 517,
	"./_resources/tol/TOL.jpg": 518,
	"./_resources/tol/TOL_1.jpg": 519,
	"./_resources/tol/TOL_2.jpg": 520,
	"./_resources/tol/TOL_3.jpg": 521,
	"./_resources/tol/TOL_4.jpg": 522,
	"./about/activities/2013_xmas_party.jpg": 523,
	"./about/activities/20th_anniversary.jpg": 524,
	"./about/activities/brownbag.jpg": 525,
	"./banners/activities.jpg": 148,
	"./banners/alumni.jpg": 134,
	"./banners/cldc.jpg": 145,
	"./banners/contact_info.jpg": 149,
	"./banners/corpora.jpg": 146,
	"./banners/current_courses.jpg": 141,
	"./banners/degree_requirements.jpg": 142,
	"./banners/events.jpg": 150,
	"./banners/facilities.jpg": 151,
	"./banners/faculty.jpg": 126,
	"./banners/funding.jpg": 139,
	"./banners/home.jpg": 124,
	"./banners/international_students.jpg": 140,
	"./banners/job_openings.jpg": 152,
	"./banners/lic.jpg": 138,
	"./banners/location.jpg": 153,
	"./banners/ma_programs.jpg": 135,
	"./banners/mobile/activities.jpg": 526,
	"./banners/mobile/alumni.jpg": 527,
	"./banners/mobile/cldc.jpg": 528,
	"./banners/mobile/contact_info.jpg": 529,
	"./banners/mobile/corpora.jpg": 530,
	"./banners/mobile/current_courses.jpg": 531,
	"./banners/mobile/degree_requirements.jpg": 532,
	"./banners/mobile/events.jpg": 533,
	"./banners/mobile/facilities.jpg": 534,
	"./banners/mobile/faculty.jpg": 535,
	"./banners/mobile/funding.jpg": 536,
	"./banners/mobile/home.jpg": 537,
	"./banners/mobile/international_students.jpg": 538,
	"./banners/mobile/job_openings.jpg": 539,
	"./banners/mobile/lic.jpg": 540,
	"./banners/mobile/location.jpg": 541,
	"./banners/mobile/ma_programs.jpg": 542,
	"./banners/mobile/news.jpg": 543,
	"./banners/mobile/newsletters.jpg": 544,
	"./banners/mobile/online_courses.jpg": 545,
	"./banners/mobile/phd_programs.jpg": 546,
	"./banners/mobile/post_doc.jpg": 547,
	"./banners/mobile/research.jpg": 548,
	"./banners/mobile/rogil.jpg": 549,
	"./banners/mobile/staff.jpg": 550,
	"./banners/mobile/students.jpg": 551,
	"./banners/mobile/tol.jpg": 552,
	"./banners/news.jpg": 154,
	"./banners/newsletters.jpg": 155,
	"./banners/ntue_workshop.jpg": 147,
	"./banners/online_courses.jpg": 144,
	"./banners/phd_programs.jpg": 137,
	"./banners/post_doc.jpg": 131,
	"./banners/research.jpg": 143,
	"./banners/rogil.jpg": 156,
	"./banners/staff.jpg": 132,
	"./banners/students.jpg": 133,
	"./banners/tol.jpg": 157,
	"./bgbottom.png": 553,
	"./bgtop.png": 554,
	"./default_image.jpg": 555,
	"./diamond4_ipa.png": 556,
	"./events/activity_Matsumi.jpg": 557,
	"./events/lecture268.jpg": 558,
	"./f_logo_RGB-White_114.png": 120,
	"./gil_logo.png": 117,
	"./home/2018_xmas_party.jpg": 123,
	"./home/cognition.png": 59,
	"./home/corridor.jpg": 125,
	"./home/discussion.jpg": 122,
	"./home/information.png": 60,
	"./home/language.png": 58,
	"./icons/address.png": 559,
	"./icons/cv.png": 130,
	"./icons/education.png": 128,
	"./icons/email.png": 38,
	"./icons/external_link.png": 118,
	"./icons/facebook.png": 560,
	"./icons/fax.png": 61,
	"./icons/google_map.png": 561,
	"./icons/internal_link.png": 121,
	"./icons/language.png": 562,
	"./icons/office_hour.png": 62,
	"./icons/pdf_link.png": 136,
	"./icons/phone.png": 52,
	"./icons/pin.png": 57,
	"./icons/target.png": 129,
	"./icons/title.png": 127,
	"./icons/website.png": 49,
	"./news/full_time_teaching_position_en.jpg": 563,
	"./ntulogo.png": 119,
	"./people/faculty/chenhao_chiu.jpg": 564,
	"./people/faculty/chia_lin_lee.jpg": 565,
	"./people/faculty/chia_rung_lu.jpg": 566,
	"./people/faculty/default_image.jpg": 567,
	"./people/faculty/janice_fon.jpg": 568,
	"./people/faculty/li_may_sung.jpg": 569,
	"./people/faculty/lily_i_wen_su.jpg": 570,
	"./people/faculty/lily_i_wen_su_2.jpg": 571,
	"./people/faculty/shu_kai_hsieh.png": 572,
	"./people/faculty/shuanfan_huang.jpg": 573,
	"./people/faculty/tai_li_chou.jpg": 574,
	"./people/faculty/wen_yu_chiang.jpg": 575,
	"./people/faculty/yu_hung_chang.jpg": 576,
	"./people/postdoc/yu_hsiang_tseng.jpg": 577,
	"./people/students/aarin_sirima.jpg": 578,
	"./people/students/abner_chen.jpg": 579,
	"./people/students/alexander_chen.jpg": 580,
	"./people/students/alisa_yang.jpg": 581,
	"./people/students/amber_wang.jpg": 582,
	"./people/students/an_ting_deng.jpg": 583,
	"./people/students/andrew_h.c.jpg": 584,
	"./people/students/angel_chang.jpg": 585,
	"./people/students/angela_wang.png": 586,
	"./people/students/april_yeh.jpg": 587,
	"./people/students/benjamin_hsu.jpg": 588,
	"./people/students/bonnie_liu.jpg": 589,
	"./people/students/caridee_kao.jpg": 590,
	"./people/students/chan_chia_hsu.jpg": 591,
	"./people/students/chen_yu_chester_hsieh.png": 592,
	"./people/students/chia_chen_lee.jpg": 593,
	"./people/students/chia_yin_chen.jpg": 594,
	"./people/students/chia_ying_yang.jpg": 595,
	"./people/students/chih_chieh_chang.jpg": 596,
	"./people/students/chih_yao_lee.jpg": 597,
	"./people/students/chih_yi_wu.jpg": 598,
	"./people/students/ching_wei_hsu.jpg": 599,
	"./people/students/chor_kiu_lee.jpg": 600,
	"./people/students/chun_wei_hsu.jpg": 601,
	"./people/students/cing_fang_andrea_shih.jpg": 602,
	"./people/students/cj_young.jpg": 603,
	"./people/students/claire_chang.jpg": 604,
	"./people/students/craig_yu_chun_yang.jpg": 605,
	"./people/students/david_chen.jpg": 606,
	"./people/students/debbie_chang.jpg": 607,
	"./people/students/debby_chang.jpg": 608,
	"./people/students/default_image.jpg": 609,
	"./people/students/emily_lu.jpg": 610,
	"./people/students/ethan_shih.jpg": 611,
	"./people/students/feiyang_zhang.jpg": 612,
	"./people/students/freya_yeh.jpg": 613,
	"./people/students/greg_vondiziano.jpg": 614,
	"./people/students/han_tang_hung.jpg": 615,
	"./people/students/hanna_wu.jpg": 616,
	"./people/students/hsin_yen_chen.jpg": 617,
	"./people/students/hsing_chen_liu.jpg": 618,
	"./people/students/hsu_hung_ke.jpg": 619,
	"./people/students/hui_yu_chien.jpg": 620,
	"./people/students/iju_hsu.jpg": 621,
	"./people/students/jessica_lin.jpg": 622,
	"./people/students/jessy_chen.jpg": 623,
	"./people/students/jia_cheng_xu.jpg": 624,
	"./people/students/jimmy_shih.jpg": 625,
	"./people/students/judy_kang.jpg": 626,
	"./people/students/jung_sheng_chang.jpg": 627,
	"./people/students/kathy_yen.jpg": 628,
	"./people/students/kuo_shu_wang.jpg": 629,
	"./people/students/ling_chen_chou.jpg": 630,
	"./people/students/ling_tang.jpg": 631,
	"./people/students/ludwig_zhang.jpg": 632,
	"./people/students/mao_chang_ku.jpg": 633,
	"./people/students/meng_hsien_shih.jpg": 634,
	"./people/students/miffy_lin.jpg": 635,
	"./people/students/minjae_lee.jpg": 636,
	"./people/students/nai_hsin_li.jpg": 637,
	"./people/students/naiwen_aileen_chang.jpg": 638,
	"./people/students/nguyen_thanh_hoa.jpg": 639,
	"./people/students/nick_li.jpg": 640,
	"./people/students/nina_yeh.jpg": 641,
	"./people/students/patricia_yang.jpg": 642,
	"./people/students/phoebe_chiang.jpg": 643,
	"./people/students/po_heng_chen.jpg": 644,
	"./people/students/po_wei_li.jpg": 645,
	"./people/students/reddick_li_xing_yang.jpg": 646,
	"./people/students/ree_lin.jpg": 647,
	"./people/students/richard_lian.jpg": 648,
	"./people/students/rita_tsao.jpg": 649,
	"./people/students/rosa_ma.png": 650,
	"./people/students/rui_liang_xu.jpg": 651,
	"./people/students/sally_chen.jpg": 652,
	"./people/students/sam_fisher.jpg": 653,
	"./people/students/sandy_tsai.jpg": 654,
	"./people/students/shanon_lin.jpg": 655,
	"./people/students/sheng_chieh_chang.png": 656,
	"./people/students/sherry_chen.jpg": 657,
	"./people/students/taniguchi_shiori.jpg": 658,
	"./people/students/te_wei.jpg": 659,
	"./people/students/thomas_schlatter.jpg": 660,
	"./people/students/thomas_van_hoey.jpg": 661,
	"./people/students/tsun_jui_liu.jpg": 662,
	"./people/students/tzu_hung_lu.jpg": 663,
	"./people/students/tzu_yun_huang.jpg": 664,
	"./people/students/umy_chang.jpg": 665,
	"./people/students/veasna_lee.jpg": 666,
	"./people/students/wang_kai_hong.jpg": 667,
	"./people/students/wei_lan.jpg": 668,
	"./people/students/wen_chi_shen.jpg": 669,
	"./people/students/wen_yi_huang.jpg": 670,
	"./people/students/yi_an_wu.jpg": 671,
	"./people/students/yi_ting_tsai.jpg": 672,
	"./people/students/yin_ching_chang.jpg": 673,
	"./people/students/yolanda_ying_yu_chen.jpg": 674,
	"./people/students/yongfu_liao.jpg": 675,
	"./people/students/yu_hsuan_liao.jpg": 676,
	"./people/students/yu_wen_liu.jpg": 677,
	"./people/students/yu_yun_chang.jpg": 678,
	"./people/students/yuki_wu.jpg": 679,
	"./people/students/yun_ingrid_chuang.jpg": 680,
	"./people/students/yvonne_chuang.jpg": 681,
	"./people/students/zoe_huang.jpg": 682,
	"./research/Brain_Lang.Proc.Lab.jpeg": 186,
	"./research/Chiu.jpeg": 187,
	"./research/FoneticsLab.jpeg": 188,
	"./research/Lope.jpeg": 189,
	"./research/Lu.jpeg": 190,
	"./research/Su.jpeg": 191,
	"./research/Sung.jpeg": 192,
	"./research/WellbeingLab.jpeg": 193,
	"./resources/cldc/cldc9_1.jpg": 196,
	"./resources/cldc/cldc9_10.jpg": 197,
	"./resources/cldc/cldc9_11.jpg": 198,
	"./resources/cldc/cldc9_12.jpg": 199,
	"./resources/cldc/cldc9_13.jpg": 200,
	"./resources/cldc/cldc9_14.jpg": 201,
	"./resources/cldc/cldc9_15.jpg": 202,
	"./resources/cldc/cldc9_16.jpg": 203,
	"./resources/cldc/cldc9_2.jpg": 204,
	"./resources/cldc/cldc9_3.jpg": 205,
	"./resources/cldc/cldc9_4.jpg": 206,
	"./resources/cldc/cldc9_5.jpg": 207,
	"./resources/cldc/cldc9_6.jpg": 208,
	"./resources/cldc/cldc9_7.jpg": 209,
	"./resources/cldc/cldc9_8.jpg": 210,
	"./resources/cldc/cldc9_9.jpg": 211,
	"./resources/cldc/cldc9_poster.png": 212,
	"./resources/corpora/corpora_PTT.jpg": 213,
	"./resources/corpora/corpora_formosan.jpg": 214,
	"./resources/facilities/EGG.jpg": 216,
	"./resources/facilities/EMG.jpg": 217,
	"./resources/facilities/ERP.png": 218,
	"./resources/facilities/audio_recorder.jpg": 219,
	"./resources/facilities/eye_tracker.jpg": 220,
	"./resources/facilities/response_box.jpg": 221,
	"./resources/facilities/sound_proof_recording_room.jpeg": 222,
	"./resources/facilities/ultrasound_technology.jpg": 223,
	"./resources/ntue/Articut01.png": 176,
	"./resources/ntue/C_Hendrix_Sun.jpg": 177,
	"./resources/ntue/H_Baayen.jpg": 178,
	"./resources/ntue/H_Yang.jpg": 179,
	"./resources/ntue/P_Hendrix.jpg": 180,
	"./resources/ntue/Y_Chang.jpg": 181,
	"./resources/ntue/Y_Chuang.jpg": 182,
	"./resources/ntue/ma.png": 183,
	"./resources/ntue/ntue_1.jpg": 184,
	"./resources/ntue/ntue_2.jpg": 185,
	"./resources/ntue/photo_album/1128.jpg": 84,
	"./resources/ntue/photo_album/DSC03491.JPG": 85,
	"./resources/ntue/photo_album/DSC03495.JPG": 86,
	"./resources/ntue/photo_album/DSC03527.JPG": 87,
	"./resources/ntue/photo_album/DSC03532.JPG": 88,
	"./resources/ntue/photo_album/DSC03534.JPG": 89,
	"./resources/ntue/photo_album/DSC03537.JPG": 90,
	"./resources/ntue/photo_album/DSC03543.JPG": 91,
	"./resources/ntue/photo_album/DSC03553.JPG": 92,
	"./resources/ntue/photo_album/DSC03556.JPG": 93,
	"./resources/ntue/photo_album/DSC03563.JPG": 94,
	"./resources/ntue/photo_album/DSC03572.JPG": 95,
	"./resources/ntue/photo_album/DSC03586.JPG": 96,
	"./resources/ntue/photo_album/DSC03592.JPG": 97,
	"./resources/ntue/photo_album/DSC03599.JPG": 98,
	"./resources/ntue/photo_album/IMG_20191128_112118.jpg": 99,
	"./resources/ntue/photo_album/IMG_20191128_171651.jpg": 100,
	"./resources/ntue/photo_album/IMG_7052.png": 101,
	"./resources/ntue/photo_album/IMG_7056.jpg": 102,
	"./resources/ntue/photo_album/IMG_7061.jpg": 103,
	"./resources/ntue/photo_album/IMG_7064.jpg": 104,
	"./resources/ntue/photo_album/IMG_7073.jpg": 105,
	"./resources/ntue/photo_album/IMG_7082.jpg": 106,
	"./resources/ntue/photo_album/IMG_7095.jpg": 107,
	"./resources/ntue/photo_album/IMG_7104.jpg": 108,
	"./resources/ntue/photo_album/IMG_7112.jpg": 109,
	"./resources/ntue/photo_album/IMG_7122.jpg": 110,
	"./resources/ntue/photo_album/IMG_7128.jpg": 111,
	"./resources/ntue/photo_album/IMG_7140.jpg": 112,
	"./resources/ntue/photo_album/IMG_7144.jpg": 113,
	"./resources/ntue/photo_album/NTUEworkshop-1128-00010.JPG": 114,
	"./resources/ntue/photo_album/NTUEworkshop-1128-00018.jpg": 115,
	"./resources/ntue/photo_album/NTUEworkshop-1129-00002.jpg": 116,
	"./resources/online_courses/online_courses_Chao_Yuen-Ren.jpg": 194,
	"./resources/online_courses/online_courses_Su_I-Wen.jpg": 72,
	"./resources/online_courses/online_courses_Wang_Shi-Yuan.jpg": 195,
	"./resources/rogil/rogil.jpg": 224,
	"./resources/tol/LingHacks2019.jpg": 225,
	"./resources/tol/TOL.jpg": 226,
	"./yt_logo_mono_dark.png": 168
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 215;